import { h } from 'preact';
import * as BaseComp from 'components/bolt/signUpForm/signUpForm.js';
import Store from 'store/store';
import 'store/bolt/signUpBanner';
import { joinClasses, accessNested } from 'utils/utils';
import s from 'components/bolt/signUpForm/signUpForm.sss';

export default class SignUpForm extends BaseComp.default {
	constructor(props) {
		super(props);
		this.formType = accessNested(Store.get(), 'appData.options.formEmbeds.signUp.formType', {});
		this.useKlaviyo = this.formType === 'klaviyo';
		this.FormTag = this.useKlaviyo ? 'div' : 'form';
		this.state = { email: '' };
		this.klaviyoSubscribe = this.klaviyoSubscribe.bind(this);
		this.subscribe = this.subscribe.bind(this);
	}

	klaviyoSubscribe(listId, email, params = {}) {
		const config = Object.assign({}, params, {
			g: listId,
			email
		});

		const body = Object.keys(config).reduce((str, key) => {
			str.append(key, config[key]);
			return str;
		}, new URLSearchParams());

		return fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
			method: 'POST',
			headers: {
				'Access-Control-Allow-Headers': '*',
				'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
			},
			body
		}).then(res => res.json());
	}

	subscribe(e) {
		const data = this.props.data;
		const { email } = this.state;

		if (data.listId && email) {
			let title = Store.get().appData?.meta?.title?.slug;
			this.klaviyoSubscribe(data.listId, email, {
				$fields: '$source',
				$source: title ? title + '-tickets' : 'powster-form'
			}).then(response => {
				if (response.data.is_subscribed) {
					this.closeBanner(e, 'already-subscribed');
				} else if (response.success) {
					this.closeBanner(e, 'subscribed');
				} else {
					console.error(response);
				}
			});
		} else {
			console.error('Please make sure you provided a klaviyo listId and an email first.');
		}
	}

	getForm() {
		let form;
		const { data } = this.props;
		const btnData = data.button || {};

		if (this.useKlaviyo) {
			const submitBtn = (
				<input
					type="submit"
					class={joinClasses(s.button, s.submitFormBtn)}
					value={btnData.label}
					name="subscribe"
					ariaLabel={btnData.ariaLabel}
					onClick={(e) => this.subscribe(e)}
				/>
			);

			form = (
				<div class={joinClasses(s.inputContainer, s.emailInputContainer)} ref={ref => this.$inputContainer = ref}>
					<input type="email" class={s.email} value={this.state.email} onChange={(e) => this.setState({ email: e.target.value })} name="EMAIL" id="klaviyo-EMAIL" placeholder={data.emailPlaceholder || 'Email address'} required />
					<input type="text" class={s.antiBot} name={'b_' + this.u + '_' + this.id} tabindex="-1" value="" aria-hidden="true" />
					{submitBtn}
				</div>
			);

			return form;
		} else {
			return super.getForm();
		}
	}
}
